<template>
  <DialogTemplateToolkit
    class="without-criteria-confirmation-dialog"
    :dialog="dialog"
    first_btn="Tenders.Continue"
    :title="$t('Tenders.SureWthoutCriteria')"
    @apply="apply"
    @close="dialog = false">
    <template #activator-btn>
      <sButton
        :disabled="disabled"
        @click="dialog = true">
        {{ $t('Common.Next') }}
      </sButton>
    </template>
    <template #card-text>
      {{ $t('Tenders.SuppliersWIndicateOnlyPrice') }}
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'withoutCriteriaConfirmationDialog',
  data() {
    return {
      dialog: false
    }
  },
  props: {
    nextFunc: Function,
    disabled: Boolean
  },
  methods: {
    apply() {
      this.nextFunc()
    }
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
